import React from "react";
import DownloadButton from "./DownloadButton";
import pdficon from "../../Common/FilesRelevent/pdf.png";
import DisplayFileExtensionWise from "./DisplayFileExtensionWise";

export default function DownloadwithDisplayProper({ item }) {
  const handleImageError = (e) => {
    e.target.src = pdficon;
  };
  
  return (
    <div  className="download-top-btn ">
      <DisplayFileExtensionWise
        item={item}
        className="cover-img"
        alt="Certificate"
        onError={handleImageError}
      />
      <DownloadButton file={item} />
    </div>
  );
}
